const fonts = {
  avenirNextHeavy: "avenir-next-heavy, system, sans-serif",
  avenirHeavy: "avenir-heavy, system, sans-serif",
  avenirNextBold: "avenir-next-bold, system, sans-serif",
  avenirNextDemi: "avenir-next-demi, system, sans-serif",
  avenirNextMedium: "avenir-next-medium, system, sans-serif",
  avenirNextRegular: "avenir-next-regular, system, sans-serif",
  avenirNextThin: "avenir-next-thin, system, sans-serif"
}

export default fonts
